export const services = [
  { id: 1, name: "Вторресурсы" },
  { id: 2, name: "Клининг" },
  { id: 3, name: "Разнарабочие" },
  { id: 4, name: "Транспортные" },
];
